import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ServerService } from '../../service/server/server.service';

@Component({
  selector: 'app-sale-shop-process',
  templateUrl: './sale-shop-process.component.html',
  styleUrls: ['./sale-shop-process.component.css']
})
export class SaleShopProcessComponent implements OnInit, OnDestroy {
  public isOnline: any;
  public loading = false;
  public subscription: Subscription;
  public err: string; public err_validation: boolean = false;
  public err_internet_text: string; public err_internet_validation: boolean;
  public server: any;
  public id: number;
  public username: any;
  public title: string;
  public hover1: string;
  public currency: string;
  public discount_festival: number;
  public hover2: string;
  public hover3: string;
  public sho: string;
  public comment: any;
  public shop_menu_shop_attachment1: any;
  public shop_menu_shop_attachment2: any;
  public shop_menu_shop_attachment3: any;
  public shop_menu_shop_attachment4: any;
  public shop_menu_shop_attachment5: any;
  public shop_menu_shop_attachment6: any;
  public shop_menu_shop_site: any;
  public contract: string;
  public status_id: number;
  public list_status: any = [];
  public pattern_title_with_persian: any;
  public status_title: string;
  public result: any;
  public list_process: any = [];
  public process: any;

  constructor(public serverService: ServerService, public router: Router,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public dialogRef: MatDialogRef<SaleShopProcessComponent>) {
    if (this.dialog_data != null) {
      this.id = this.dialog_data.id;
    }
  }//end consructor

  ngOnInit() {
    this.server = localStorage.getItem("server");
    this.username = localStorage.getItem("username");
    this.pattern_title_with_persian = this.serverService.pattern_title_with_persian();
    this.get_process();
    this.recieve_status();
  }

  get_shop() {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'shop_menu_get_product', { id: this.id }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.title = res['result'][0].shop_menu_shop_title;
            this.hover1 = res['result'][0].shop_menu_shop_hover1;
            this.hover2 = res['result'][0].shop_menu_shop_hover2;
            this.hover3 = res['result'][0].shop_menu_shop_hover3;
            this.comment = res['result'][0].shop_menu_shop_comment;
            this.sho = res['result'][0].shop_menu_shop_sho;
            this.currency = res['result'][0].shop_menu_shop_currency;
            this.discount_festival = res['result'][0].shop_menu_shop_discount_festival;
            this.contract = res['result'][0].shop_menu_shop_contract;
            this.process = res['result'][0].shop_menu_shop_process;
            this.shop_menu_shop_attachment1 = res['result'][0].shop_menu_shop_attachment1;
            this.shop_menu_shop_attachment2 = res['result'][0].shop_menu_shop_attachment2;
            this.shop_menu_shop_attachment3 = res['result'][0].shop_menu_shop_attachment3;
            this.shop_menu_shop_attachment4 = res['result'][0].shop_menu_shop_attachment4;
            this.shop_menu_shop_attachment5 = res['result'][0].shop_menu_shop_attachment5;
            this.shop_menu_shop_attachment6 = res['result'][0].shop_menu_shop_attachment6;
            this.shop_menu_shop_site = res['result'][0].shop_menu_shop_site;
            this.status_id = res['result'][0].status_id;
            this.status_title = res['result'][0].status_title;

            if (this.process != null) {
              var x = this.process.split(",");
              for (var i = 0; i < this.list_process.length; i++) {
                this.list_process[i].process_check = 2;
              }
              for (var i = 0; i < this.list_process.length; i++) {
                for (var j = 0; j < x.length; j++) {
                  if (this.list_process[i].sale_process_id == x[j]) {
                    this.list_process[i].process_check = 1;
                  }//end if
                }
              }//end for
            }//end if

          }//end for
          this.recieve_erorr(false, false, "", "", 1);
        }//end if
        else {
          this.recieve_erorr(true, true, 'Erorr in recieve', "خطا در دريافت", 1);
        }
      }
    )
  }//end get_shop

  update() {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    var process_arr = "0";
    var x = <any>document.getElementsByName('process[]');
    for (var i = 0; i < x.length; i++) {
      if (x[i].checked == true) {
        process_arr = process_arr + "," + x[i].value;
      }
    }//end for
    process_arr = process_arr += ",";

    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'shop_menu_init_update', { "username": this.username, 'title': this.title, 'hover1': this.hover1, 'comment': this.comment, 'hover2': this.hover2, 'hover3': this.hover3, 'sho': this.sho, 'currency': this.currency, 'discount_festival': this.discount_festival, 'status_id': this.status_id, 'id': this.id, 'contract': this.contract, 'process_arr': process_arr }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          this.result = { id: res['result'][0].shop_menu_shop_id, status_title: res['result'][0].status_title }
          this.recieve_erorr(false, false, "", "", 1);
        }//end if
        else if (res['status'] == 4) {
          alert(' عنوان  مي بايست منحصر به فرد باشد ');
          this.recieve_erorr(false, false, "", "", 1);
        }
        else {
          this.recieve_erorr(true, true, 'Erorr in save', "خطا در ذخيره", 1);
        }
      }
    );
  }

  //*******************************************************************************
  get_process() {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.subscription = this.serverService.get_address(this.server, 'sales_get_process').subscribe(
      (res) => {
        this.list_process = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_process.push(res['result'][i]);
          }//end for
          this.get_shop();
          this.recieve_erorr(false, false, "", "", 2);
        }//end if
        else {
          this.recieve_erorr(true, true, 'Erorr in recieve', "خطا در دريافت", 2);
        }
      }
    )
  }//end recieve_status

  recieve_status() {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.subscription = this.serverService.get_address(this.server, 'get_status').subscribe(
      (res) => {
        this.list_status = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_status.push(res['result'][i]);
          }//end for
          this.recieve_erorr(false, false, "", "", 2);
        }//end if
        else {
          this.recieve_erorr(true, true, 'Erorr in recieve', "خطا در دريافت", 2);
        }
      }
    )
  }//end recieve_status
  //********************************************************** */
  div_select_file(inputSelect) {
    var x = <any>document.getElementById(inputSelect);
    x.click();
  }//end div_select_file

  change_input(id, uploadButton, image, type, size) {
    this.serverService.readUrl(document.getElementById(id), document.getElementById(uploadButton), image, type, size);
  }//end change_input

  upload_submit(inputSelect, whichImage, alarm, type, upload_type) {
    this.serverService.upload_submit(inputSelect, whichImage, alarm, type, this.id, 2, upload_type);
  }
  //********************************************************** */
  close() {
    this.dialogRef.close(this.result);
  }
  //**************************************************
  recieve_erorr(err_validation, loading, en_message, pe_message, type) {
    this.err_validation = err_validation;
    if (type == 1) this.loading = false;
    this.err = pe_message;
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}


